import keyboardShortcutsActionMap from '@/keyboardShortcuts';
import * as commonKeyboardActions from '../util/commonKeyboardActions';

import type { EditorAPI } from '@/editorAPI';

const QUICK_EDIT_SHORTCUTS_CONFIG = {};

const { editor: editorKeyboardMap } = keyboardShortcutsActionMap;

function addQuickEditShortcuts(editorAPI: EditorAPI) {
  const keysToMerge: Record<string, (event?: KeyboardEvent) => void> = {};

  keysToMerge[editorKeyboardMap.UNDO.key] = () =>
    commonKeyboardActions.undoFromKeyboard(editorAPI);

  keysToMerge[editorKeyboardMap.REDO.key] = () =>
    commonKeyboardActions.redoFromKeyboard(editorAPI);

  keysToMerge[editorKeyboardMap.SAVE.key] = () =>
    commonKeyboardActions.saveSiteFromKeyboard(editorAPI);

  keysToMerge[editorKeyboardMap.PUBLISH_SITE.key] = (event: KeyboardEvent) =>
    commonKeyboardActions.publishSiteFromKeyboard(editorAPI, event);

  keysToMerge[editorKeyboardMap.TOGGLE_PREVIEW.key] = (event: KeyboardEvent) =>
    commonKeyboardActions.togglePreviewFromKeyboard(editorAPI, event);

  Object.assign(QUICK_EDIT_SHORTCUTS_CONFIG, keysToMerge);
}

export default {
  init(editorAPI: EditorAPI) {
    addQuickEditShortcuts(editorAPI);
  },
  shortcuts: QUICK_EDIT_SHORTCUTS_CONFIG,
};
